<template>
    <div
        v-if="showBanner"
        class="cookie-banner"
        style="
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background-color: #333;
            color: #fff;
            padding: 10px;
            text-align: center;
            z-index: 9999;
            box-sizing: border-box;
        "
    >
        <span>{{ message }}</span>
        <a
            v-if="cookiePolicyUrl"
            :href="cookiePolicyUrl"
            style="color: #fff; text-decoration: underline; margin-left: 5px"
        >
            {{ moreInfoText }}
        </a>
        <button
            @click="acceptCookies"
            style="
                margin-bottom: 0;
                margin-left: 10px;
                background-color: #fff;
                color: #333;
                border: none;
                padding: 5px 10px;
                cursor: pointer;
                border-radius: 3px;
            "
        >
            {{ buttonText }}
        </button>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
    message: {
        type: String,
        required: true,
    },
    buttonText: {
        type: String,
        required: true,
    },
    cookiePolicyUrl: {
        type: String,
        default: null,
    },
    moreInfoText: {
        type: String,
        default: "More information",
    },
});

const showBanner = ref(false);

const isLocalStorageAvailable = () => {
    try {
        if (typeof window === "undefined" || !window.localStorage) {
            return false;
        }
        const testKey = "__test_storage__";
        window.localStorage.setItem(testKey, testKey);
        window.localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};

onMounted(() => {
    try {
        if (!isLocalStorageAvailable() || !window.localStorage.getItem("cookie_seen")) {
            showBanner.value = true;
        }
    } catch (e) {
        showBanner.value = true;
    }
});

const acceptCookies = () => {
    try {
        if (isLocalStorageAvailable()) {
            window.localStorage.setItem("cookie_seen", "true");
        }
    } catch (e) {
        // Ignore storage errors
    }
    showBanner.value = false;
};
</script>

<style scoped>
.cookie-banner {
    /* Styles are mostly inline to match existing code, but can be moved here */
}
</style>
